module.exports = __webpack_public_path__ + "bg2.3c3bf535bb66afc9a3fb.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/pages/img/frontend-slider/bg2.jpg
// module id = ../../../../../src/assets/pages/img/frontend-slider/bg2.jpg
// module chunks = styles